'use client';

import { c as _c } from "react/compiler-runtime";
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type React from 'react';
import { useState } from 'react';
export function ReactQueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new QueryClient({
      defaultOptions: {
        queries: {
          gcTime: 900000,
          refetchOnWindowFocus: false
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [client] = useState(t1);
  let t2;
  if ($[1] !== children || $[2] !== client) {
    t2 = <PersistedQueryClientProvider client={client}>{children}</PersistedQueryClientProvider>;
    $[1] = children;
    $[2] = client;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
const PersistedQueryClientProvider = t0 => {
  const $ = _c(8);
  const {
    children,
    client
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createSyncStoragePersister({
      storage: typeof window === "undefined" ? undefined : window.localStorage
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [persister] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      shouldDehydrateMutation: _temp
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== persister) {
    t3 = {
      dehydrateOptions: t2,
      persister
    };
    $[2] = persister;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== client || $[6] !== t3) {
    t4 = <PersistQueryClientProvider client={client} persistOptions={t3}>{children}</PersistQueryClientProvider>;
    $[4] = children;
    $[5] = client;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp() {
  return false;
}